import {t} from "../i18n/index.js";
// Komplet liste over PointViews tastaturgenveje - ÉN kilde til både hjælpeartiklen "Keyboard shortcuts" (helpModel.js) og
// listen i frontendens Navigation-modal (DigitizationModule.getKeyboardShortcuts()). Ren data, ingen DOM: kan enhedstestes.
//
// Hver genvej: {keys: ["Shift", "L"], description: "..."} - `keys` er en kombination (vises som "Shift + L"). Musetaster er
// skrevet som tekst ("Højreklik"), så mus+tastatur-kombinationer står samlet.
//
// Listen er udledt af koden (hver post har sin kilde angivet), ikke gættet. Kommer der en ny genvej til, SKAL den stå her -
// ellers mangler den både i hjælpen og i modalen. Genveje i tekstfelter/talfelter ignoreres af de globale genveje
// (utils/keyboardGuard.js: shouldIgnoreGlobalShortcut()).
// Bygges af en funktion, så teksterne slås op på det aktive sprog, hver gang listen læses.
function buildGroups(){
	return [
	{
		id: "general",
		title: t("Generelt"),
		items: [
			// DigitizationModule.js: Escape-handler (to niveauer: først den igangværende handling, derefter værktøjet)
			{keys: ["Esc"], description: t("Annullér den igangværende handling (påbegyndt forløb, preview, referencevalg). Er intet påbegyndt, forlader Esc det aktive værktøj.")},
			// DigitizationModule.js: ctrlHeld -> isPaused()
			{keys: ["Ctrl"], description: t("Hold nede for at sætte det aktive værktøj på pause, så du kan navigere uden at placere punkter. Slip for at fortsætte, hvor du slap.")},
			// DigitizationModule.js: "c" (coordinateInfoBox.copyCurrent())
			{keys: ["C"], description: t("Kopiér koordinatboksens X/Y/Z til udklipsholderen.")},
			// DigitizationModule.js: "l" / Shift+"l"
			{keys: ["L"], description: t("Vis eller skjul alle labels (punkter, mål og objekter). Et rørs resultat styres kun af Shift+L.")},
			{keys: ["Shift", "L"], description: t("Vis eller skjul alle resultat-labels (de orange), også rørets resultat.")},
			// viewer/PointViewTopFraming.js: "t"
			{keys: ["T"], description: t("Hop til en tæt top-visning af den indlæste punktsky.")},
			// c-potree.vue (onDigitizationClassificationKeydown) og viewer/ClassificationQuickToggles.js: "1"-"4"
			{keys: ["1"], description: t("Vis eller skjul klassifikationen Støj.")},
			{keys: ["2"], description: t("Vis eller skjul klassifikationen Terræn.")},
			{keys: ["3"], description: t("Vis eller skjul klassifikationen Anlægsgrav.")},
			{keys: ["4"], description: t("Vis eller skjul klassifikationen Ledninger.")},
			// navigation/InputHandler.js (KeyCodes.DELETE) -> utils/VolumeTool.js
			{keys: ["Delete"], description: t("Slet det markerede klip-volumen.")},
		],
	},
	{
		id: "navigation",
		title: t("Navigation (Jord-navigation)"),
		items: [
			// navigation/EarthControls.js: this.keys / getNavigationHelp() - piletaster virker kun alene
			{keys: ["↑"], description: t("Flyt fremad.")},
			{keys: ["↓"], description: t("Flyt baglæns.")},
			{keys: ["←"], description: t("Flyt til venstre.")},
			{keys: ["→"], description: t("Flyt til højre.")},
			{keys: ["Alt", "↑"], description: t("Flyt op.")},
			{keys: ["Alt", "↓"], description: t("Flyt ned.")},
			{keys: ["Shift", "←"], description: t("Drej blikket til venstre.")},
			{keys: ["Shift", "→"], description: t("Drej blikket til højre.")},
			{keys: ["Shift", "↑"], description: t("Se nedad.")},
			{keys: ["Shift", "↓"], description: t("Se opad.")},
		],
		note: t("Kreds-navigation har ingen tastaturbetjening - den bruges kun med musen."),
	},
	{
		id: "tools",
		title: t("Værktøjer og dialoger"),
		items: [
			// tools/circleTool.js, tools/rectangleTool.js (værktøjets prompt): Enter/Escape
			{keys: ["Enter"], description: t("Bekræft i værktøjets dialog (fx radius ved Cirkel, bredde ved Rektangel).")},
			{keys: ["Esc"], description: t("Luk eller annullér den åbne dialog, menu eller panel uden at gemme.")},
			// modules/ProfileOverlays/ProfileTools.js: Enter / Backspace / Escape (tegning i 2D-profilen)
			{keys: ["Enter"], description: t("2D-profil: afslut det forløb, du er ved at tegne (måling/digitalisering i profilen).")},
			{keys: ["Backspace"], description: t("2D-profil: fjern det sidst placerede punkt i det forløb, du tegner.")},
			// modules/PrecisionMeasure/PrecisionMeasure.js: "g" (laser) og Enter (face-point)
			{keys: ["G"], description: t("3-akset laser (model): skift akserne mellem fladens egne akser og Ø/N/op.")},
			{keys: ["Enter"], description: t("Flade til punkt (model): vælg en ny IFC-flade.")},
			// components/pointcloud/registreringer-panel.vue: søgefelt / omdøbning
			{keys: ["Esc"], description: t("Registreringer: ryd søgefeltet, eller annullér en omdøbning.")},
		],
	},
	{
		id: "mouse",
		title: t("Mus og tastatur sammen"),
		items: [
			// DigitizationModule.js (Shift+højreklik -> openVertexMenu/openFeatureMenu)
			{keys: ["Shift", t("Højreklik")], description: t("Åbn redigeringsmenuen for punktet, segmentet eller geometrien under cursoren.")},
			// BoxSelection.js
			{keys: ["Ctrl", t("Højreklik"), t("træk")], description: t("Vælg flere geometrier med et rektangel.")},
			// DigitizationModule.js / idleRightClick.js (plain right-click i idle = Esc)
			{keys: [t("Højreklik")], description: t("Er et værktøj aktivt, men intet er påbegyndt, afslutter et almindeligt højreklik værktøjet (som Esc). Er du i gang med et forløb (fx Linje eller Polygon), afslutter det forløbet.")},
			// components/pointcloud/ifc-model.vue: onModelClick/onTreeLabelClick (Ctrl/Cmd)
			{keys: ["Ctrl", t("Klik")], description: t("IFC/Model: tilføj eller fjern et element i markeringen.")},
			// components/pointcloud/ifc-model.vue: onCanvasWheel (Ctrl + hjul, 5 cm pr. klik)
			{keys: ["Ctrl", t("Rul")], description: t("IFC/Model: flyt det aktive snit langs sin normal (5 cm pr. klik).")},
		],
	},
	];
}

// Frisk kopi (på det aktive sprog), så en bruger af listen ikke kan ændre kilden.
export function getKeyboardShortcutGroups(){
	return buildGroups().map((group) => ({
		id: group.id,
		title: group.title,
		note: group.note || null,
		items: group.items.map((item) => ({keys: [...item.keys], description: item.description})),
	}));
}

// "Shift + L"
export function formatShortcutKeys(keys){
	return keys.join(" + ");
}
